// src/components/Navbar.js
import React from "react";
import "./Navbar.css";
import logo1 from "../assets/OmHaus_LOGO.png"; // Add your omHaus image
import logo4 from "../assets/logo.png";
import logo2 from "../assets/e6a.png";
import logo3 from "../assets/olivares.png";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-icon">
          <img src={logo1} alt="Icon 1" className="nav-icon-img" />
        </div>
        <div className="nav-icon">
          <img src={logo2} alt="Icon 2" className="nav-icon-img" />
        </div>
        <div className="nav-icon">
          <img src={logo3} alt="Icon 3" className="nav-icon-img" />
        </div>
        <div className="nav-icon">
          <img src={logo4} alt="Icon 4" className="nav-icon-img" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
